import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { ArrowRightIcon } from '../../Icons/ArrowRightIcon';

interface IProps {
  blogSlug: string;
  authorNickname: string;
}

export const BlogAuthorLink = ({ blogSlug, authorNickname }: IProps) => (
  <InternalLink
    variant="buttonTertiary"
    to={`/blog/authors/${blogSlug}`}
    className="flex gap-2 !bg-sea-foam p-4"
  >
    <span className="line-clamp-1 text-ellipsis break-all">{`Blog posts by ${authorNickname}`}</span>
    <ArrowRightIcon size={20} className="min-w-5" />
  </InternalLink>
);
